/**
 * Driver Activity tools WaterGo keeps for admins, beyond the edit permission each one also needs. Hosts grant
 * these to admins (DispatchGo's permission generator does); a role can be given them through RBAC as well.
 */
export const DRIVER_ACTIVITY_PERMISSIONS = {
  /** Merging and splitting shifts, visits, and split transports: WaterGo's admin-only structure tools. */
  restructure: "driveractivity_restructure",
  /** A ticket's well allocation. */
  wellAllocation: "wellallocation_view",
} as const;

/** Whether every permission is held: a tool needing several needs them all. */
export const holdsAll = (can: (permission: string) => boolean, permissions: string | readonly string[]) =>
  (typeof permissions === "string" ? [permissions] : permissions).every(can);
